// extracted by mini-css-extract-plugin
export default {"loadingContainer":"tenantSubscriptionInfo_loadingContainer__tMRdb","container":"tenantSubscriptionInfo_container__c3bcQ","section":"tenantSubscriptionInfo_section__zvHbe"};